(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.isOverlayHeader =
        this.classList.contains('header-wrapper--home') ||
        this.classList.contains('header-wrapper--product') ||
        this.classList.contains('header-wrapper--runway') ||
        this.classList.contains('header-wrapper--appointment');
      this.headerBounds = {};
      this.updateOverlayHeaderBounds = this.updateOverlayHeaderBounds.bind(this);

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      if (this.isOverlayHeader) {
        this.updateOverlayHeaderBounds();
      }
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.isOverlayHeader) {
        window.removeEventListener('resize', this.updateOverlayHeaderBounds);
        window.removeEventListener('vaillant:announcement-dismissed', this.updateOverlayHeaderBounds);
      }
    }

    updateOverlayHeaderBounds() {
      if (!this.isOverlayHeader) return;

      const announcementHeight =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--vaillant-announcement-height')
        ) || 0;

      this.headerBounds = {
        top: 0,
        bottom: announcementHeight + this.header.offsetHeight,
      };
    }

    createObserver() {
      if (this.isOverlayHeader) {
        this.updateOverlayHeaderBounds();
        window.addEventListener('resize', this.updateOverlayHeaderBounds);
        window.addEventListener('vaillant:announcement-dismissed', this.updateOverlayHeaderBounds);
        return;
      }

      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      const scrollThreshold = this.headerBounds.bottom || 0;
      const resetScrollTop = this.isOverlayHeader ? 0 : this.headerBounds.top;

      if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= resetScrollTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-vaillant"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerVaillantController {
    constructor(host) {
      this.host = host;
      this.videos = [...host.querySelectorAll('.hero-banner-vaillant__video')];
      this.desktopVideo = host.querySelector('.hero-banner-vaillant__video--desktop');
      this.mobileVideo = host.querySelector('.hero-banner-vaillant__video--mobile');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      if (!this.videos.length) return;

      this.videos.forEach((video) => {
        video.muted = true;
      });

      this.controls = new VaillantVideoControls(host, {
        getActiveVideo: () => this.activeVideo || this.getActiveVideo(),
        getVideos: () => this.videos,
      });

      this.mobileQuery.addEventListener?.('change', () => this.switchVideo());
      this.switchVideo();

      if (!host.querySelector('.hero-banner-vaillant__link')) {
        host.querySelector('.hero-banner-vaillant__media')?.addEventListener('click', (event) => {
          if (event.target.closest('[data-vaillant-video-controls]')) return;
          this.controls?.togglePlayback();
        });
      }
    }

    getActiveVideo() {
      if (this.mobileQuery.matches && this.mobileVideo) return this.mobileVideo;
      return this.desktopVideo || this.mobileVideo;
    }

    switchVideo() {
      const nextVideo = this.getActiveVideo();
      if (this.activeVideo && this.activeVideo !== nextVideo) this.activeVideo.pause();
      this.activeVideo = nextVideo;

      VaillantVideoMedia.playWhenReady(this.activeVideo, {
        userPaused: this.controls?.userPaused,
      });

      this.controls?.refresh();
    }
  }

  const initHeroBannerControls = () => {
    document.querySelectorAll('.hero-banner-vaillant').forEach((host) => {
      if (host.dataset.heroControlsReady === 'true') return;
      host.dataset.heroControlsReady = 'true';
      new HeroBannerVaillantController(host);
    });
  };

  initHeroBannerControls();
  document.addEventListener('shopify:section:load', initHeroBannerControls);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inside-vaillant"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.insideVaillantNavigationInitialized) return;
    window.insideVaillantNavigationInitialized = true;

    const detailSectionSelector = '.section-savoir-faire-video, .section-savoir-faire-images';
    const supportedPaths = new Set([
      '/pages/inside-vaillant',
      '/pages/craftsmanship',
      '/pages/developpement-durable',
    ]);
    let activeRequest;

    const hasInsideVaillant = () => Boolean(document.querySelector('.section-inside-vaillant'));

    const isSupportedUrl = (url) =>
      url.origin === window.location.origin &&
      supportedPaths.has(url.pathname) &&
      (url.pathname === '/pages/inside-vaillant' || url.searchParams.get('view')?.startsWith('inside-vaillant-'));

    const updateCards = (currentSection, nextSection) => {
      const currentCards = [...currentSection.querySelectorAll('.inside-vaillant__card')];
      const nextCards = [...nextSection.querySelectorAll('.inside-vaillant__card')];

      currentCards.forEach((card, index) => {
        const isActive = nextCards[index]?.classList.contains('inside-vaillant__card--active') || false;
        const link = card.querySelector('.inside-vaillant__card-link');

        card.classList.toggle('inside-vaillant__card--active', isActive);
        if (isActive) {
          link?.setAttribute('aria-current', 'page');
        } else {
          link?.removeAttribute('aria-current');
        }
      });
    };

    const updateDetailSections = (currentMain, nextMain) => {
      currentMain.querySelectorAll(detailSectionSelector).forEach((section) => section.remove());

      const currentInsideSection = currentMain.querySelector('.section-inside-vaillant');
      let insertionPoint = currentInsideSection;

      [...nextMain.children]
        .filter((element) => element.matches?.(detailSectionSelector))
        .forEach((element) => {
          const nextElement = document.importNode(element, true);
          insertionPoint.after(nextElement);
          insertionPoint = nextElement;
        });
    };

    const switchContent = async (destination, addHistory = true) => {
      const url = new URL(destination, window.location.href);
      const currentMain = document.querySelector('#MainContent');
      const currentInsideSection = currentMain?.querySelector('.section-inside-vaillant');
      if (!currentMain || !currentInsideSection || !isSupportedUrl(url)) return false;

      activeRequest?.abort();
      activeRequest = new AbortController();
      currentMain.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          signal: activeRequest.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error(`Inside Vaillant request failed: ${response.status}`);

        const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextMain = nextDocument.querySelector('#MainContent');
        const nextInsideSection = nextMain?.querySelector('.section-inside-vaillant');
        if (!nextMain || !nextInsideSection) throw new Error('Inside Vaillant content was not found');

        const scrollPosition = { left: window.scrollX, top: window.scrollY };
        updateCards(currentInsideSection, nextInsideSection);
        updateDetailSections(currentMain, nextMain);
        document.title = nextDocument.title;

        if (addHistory) history.pushState({ insideVaillant: true }, '', url);
        window.scrollTo(scrollPosition);
        requestAnimationFrame(() => window.scrollTo(scrollPosition));
        return true;
      } catch (error) {
        if (error.name === 'AbortError') return true;
        return false;
      } finally {
        currentMain.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', async (event) => {
      const link = event.target.closest('a[href*="view=inside-vaillant-"]');
      if (
        !link ||
        !hasInsideVaillant() ||
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const destination = new URL(link.href, window.location.href);
      if (!isSupportedUrl(destination)) return;

      event.preventDefault();
      const switched = await switchContent(destination);
      if (!switched) window.location.assign(destination);
    });

    window.addEventListener('popstate', async () => {
      if (!hasInsideVaillant()) return;

      const destination = new URL(window.location.href);
      if (!isSupportedUrl(destination)) {
        window.location.reload();
        return;
      }

      const switched = await switchContent(destination, false);
      if (!switched) window.location.reload();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runway-image-slider-vaillant"] && !Shopify.designMode) return;
  try {
    
  class RunwayImageSliderVaillant extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-runway-slider-track]');
      if (!this.track) return;

      this.initializeImages();
      this.bindDragEvents();
      this.track.addEventListener('keydown', (event) => this.handleKeydown(event));
    }

    initializeImages() {
      this.querySelectorAll('.runway-image-slider-vaillant__image:not(.runway-image-slider-vaillant__placeholder)').forEach((image) => {
        const slide = image.closest('[data-runway-slider-slide]');
        const reveal = () => slide?.classList.add('is-loaded');

        if (image.complete) {
          reveal();
        } else {
          image.addEventListener('load', reveal, { once: true });
          image.addEventListener('error', reveal, { once: true });
        }
      });
    }

    bindDragEvents() {
      this.track.addEventListener('pointerdown', (event) => this.handlePointerDown(event));
      this.track.addEventListener('pointermove', (event) => this.handlePointerMove(event));
      this.track.addEventListener('pointerup', (event) => this.handlePointerUp(event));
      this.track.addEventListener('pointercancel', (event) => this.handlePointerUp(event));
      this.track.addEventListener(
        'click',
        (event) => {
          if (!this.preventClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.preventClick = false;
        },
        true
      );
    }

    handlePointerDown(event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;

      this.isDragging = true;
      this.hasMoved = false;
      this.startX = event.clientX;
      this.startScrollLeft = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
      this.track.setPointerCapture?.(event.pointerId);
    }

    handlePointerMove(event) {
      if (!this.isDragging) return;

      const distance = event.clientX - this.startX;
      if (Math.abs(distance) > 3) this.hasMoved = true;
      if (!this.hasMoved) return;

      event.preventDefault();
      this.track.scrollLeft = this.startScrollLeft - distance;
    }

    handlePointerUp(event) {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.preventClick = this.hasMoved;
      this.track.classList.remove('is-dragging');
      this.track.releasePointerCapture?.(event.pointerId);

      if (this.hasMoved) this.snapToNearestSlide();
    }

    snapToNearestSlide() {
      const slide = this.querySelector('[data-runway-slider-slide]');
      if (!slide) return;

      const slideWidth = slide.getBoundingClientRect().width;
      const destination = Math.round(this.track.scrollLeft / slideWidth) * slideWidth;
      this.track.scrollTo({ left: destination, behavior: 'smooth' });
    }

    handleKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      const slide = this.querySelector('[data-runway-slider-slide]');
      if (!slide) return;

      const direction = event.key === 'ArrowRight' ? 1 : -1;
      this.track.scrollBy({ left: slide.getBoundingClientRect().width * direction, behavior: 'smooth' });
    }
  }

  if (!customElements.get('runway-image-slider-vaillant')) {
    customElements.define('runway-image-slider-vaillant', RunwayImageSliderVaillant);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runway-video-vaillant"] && !Shopify.designMode) return;
  try {
    
  class RunwayVideoVaillant extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.videos = [...this.querySelectorAll('[data-runway-video]')];
      this.desktopVideo = this.querySelector('[data-video-viewport="desktop"]');
      this.mobileVideo = this.querySelector('[data-video-viewport="mobile"]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.isVisible = false;

      this.controls = new VaillantVideoControls(this, {
        getActiveVideo: () => this.activeVideo || this.getActiveVideo(),
        getVideos: () => this.videos,
        onBeforePlay: (video) => this.loadVideo(video),
      });

      this.initializePosters();
      this.bindEvents();

      if (!this.videos.length) return;

      this.observer = new IntersectionObserver((entries) => this.handleVisibility(entries), {
        rootMargin: '200px 0px',
        threshold: 0.05,
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobileQuery?.removeEventListener?.('change', this.handleViewportChange);
      this.controls?.destroy();
    }

    initializePosters() {
      const posters = [...this.querySelectorAll('.runway-video-vaillant__poster')];
      if (!posters.length) return;

      const revealPoster = () => this.classList.add('is-loaded', 'is-poster-ready');
      posters.forEach((poster) => {
        if (poster.complete) {
          revealPoster();
        } else {
          poster.addEventListener('load', revealPoster, { once: true });
          poster.addEventListener('error', () => this.classList.add('is-loaded'), { once: true });
        }
      });
    }

    bindEvents() {
      this.handleViewportChange = () => this.activateVideo();

      this.videos.forEach((video) => {
        video.muted = true;
        video.addEventListener('canplay', () => this.classList.add('is-loaded'));
        video.addEventListener('error', () => this.classList.add('is-loaded'));
      });

      this.querySelector('[data-runway-video-media]')?.addEventListener('click', () => {
        this.controls?.togglePlayback();
      });
      this.mobileQuery.addEventListener?.('change', this.handleViewportChange);
    }

    handleVisibility(entries) {
      const entry = entries[0];
      this.isVisible = Boolean(entry?.isIntersecting);

      if (this.isVisible) {
        this.activateVideo();
      } else {
        this.activeVideo?.pause();
      }
    }

    getActiveVideo() {
      if (this.mobileQuery.matches && this.mobileVideo) return this.mobileVideo;
      return this.desktopVideo || this.mobileVideo;
    }

    activateVideo() {
      const nextVideo = this.getActiveVideo();
      if (!nextVideo) return;

      if (this.activeVideo && this.activeVideo !== nextVideo) {
        this.activeVideo.pause();
      }

      this.activeVideo = nextVideo;
      this.loadVideo(nextVideo);

      if (this.isVisible) {
        VaillantVideoMedia.playWhenReady(nextVideo, {
          userPaused: this.controls?.userPaused,
        });
      }

      this.controls?.refresh();
    }

    loadVideo(video) {
      VaillantVideoMedia.hydrate(video);
    }

  }

  if (!customElements.get('runway-video-vaillant')) {
    customElements.define('runway-video-vaillant', RunwayVideoVaillant);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savoir-faire-video"] && !Shopify.designMode) return;
  try {
    
  class SavoirFaireVideo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.videos = [...this.querySelectorAll('[data-savoir-video]')];
      this.desktopVideo = this.querySelector('[data-video-viewport="desktop"]');
      this.mobileVideo = this.querySelector('[data-video-viewport="mobile"]');
      this.frame = this.querySelector('[data-savoir-video-frame]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      this.controls = new VaillantVideoControls(this, {
        getActiveVideo: () => this.activeVideo || this.getActiveVideo(),
        getVideos: () => this.videos,
        onBeforePlay: (video) => this.loadVideo(video),
      });

      this.frame?.addEventListener('click', (event) => {
        if (event.target.closest('a, [data-vaillant-video-controls]')) return;
        this.controls?.togglePlayback();
      });
      this.mobileQuery.addEventListener?.('change', () => this.switchVideo());
      this.switchVideo();
    }

    disconnectedCallback() {
      this.controls?.destroy();
    }

    getActiveVideo() {
      if (this.mobileQuery.matches && this.mobileVideo) return this.mobileVideo;
      return this.desktopVideo || this.mobileVideo;
    }

    switchVideo() {
      const nextVideo = this.getActiveVideo();
      if (this.activeVideo && this.activeVideo !== nextVideo) this.activeVideo.pause();
      this.activeVideo = nextVideo;
      this.controls?.refresh();
    }

    loadVideo(video) {
      VaillantVideoMedia.hydrate(video);
    }

  }

  if (!customElements.get('savoir-faire-video')) {
    customElements.define('savoir-faire-video', SavoirFaireVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner-vaillant"] && !Shopify.designMode) return;
  try {
    
  class VaillantVideoBanner extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.videos = [...this.querySelectorAll('[data-video-banner-media]')];
      this.desktopVideo = this.querySelector('[data-video-viewport="desktop"]');
      this.mobileVideo = this.querySelector('[data-video-viewport="mobile"]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.isVisible = false;

      this.initializePosters();

      if (!this.videos.length) return;

      this.controls = new VaillantVideoControls(this, {
        getActiveVideo: () => this.activeVideo || this.getActiveVideo(),
        getVideos: () => this.videos,
        onBeforePlay: (video) => this.loadVideo(video),
      });

      this.videos.forEach((video) => {
        video.addEventListener('canplay', () => this.classList.add('is-loaded'));
        video.addEventListener('playing', () => this.classList.add('is-loaded', 'is-playing'));
        video.addEventListener('error', () => this.classList.add('is-loaded'));
      });

      this.querySelector('.video-banner-vaillant__media')?.addEventListener('click', (event) => {
        if (event.target.closest('a, button, [data-vaillant-video-controls]')) return;
        this.controls?.togglePlayback();
      });

      this.handleViewportChange = () => this.activateVideo();
      this.mobileQuery.addEventListener?.('change', this.handleViewportChange);

      this.observer = new IntersectionObserver(
        (entries) => {
          this.isVisible = entries.some((entry) => entry.isIntersecting);
          if (this.isVisible) {
            this.activateVideo();
          } else {
            this.activeVideo?.pause();
          }
        },
        { rootMargin: '300px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobileQuery?.removeEventListener?.('change', this.handleViewportChange);
      this.controls?.destroy();
    }

    initializePosters() {
      const posters = [...this.querySelectorAll('.video-banner-vaillant__poster')];
      if (!posters.length) return;

      const revealPoster = () => this.classList.add('is-loaded', 'is-poster-ready');

      posters.forEach((poster) => {
        if (poster.complete) {
          revealPoster();
        } else {
          poster.addEventListener('load', revealPoster, { once: true });
          poster.addEventListener('error', () => this.classList.add('is-loaded'), { once: true });
        }
      });
    }

    getActiveVideo() {
      if (this.mobileQuery.matches && this.mobileVideo) return this.mobileVideo;
      return this.desktopVideo || this.mobileVideo;
    }

    activateVideo() {
      const nextVideo = this.getActiveVideo();
      if (!nextVideo) return;

      if (this.activeVideo && this.activeVideo !== nextVideo) {
        this.activeVideo.pause();
      }

      this.activeVideo = nextVideo;
      this.loadVideo(nextVideo);

      if (this.isVisible) {
        VaillantVideoMedia.playWhenReady(nextVideo, {
          userPaused: this.controls?.userPaused,
        });
      }

      this.controls?.refresh();
    }

    loadVideo(video) {
      VaillantVideoMedia.hydrate(video);
    }
  }

  if (!customElements.get('vaillant-video-banner')) {
    customElements.define('vaillant-video-banner', VaillantVideoBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
